import axios from "axios";

export default {
    getProduct: async (productId) => {
        const { data } = await axios.get(`/products/${productId}`)
        return data
    }
}
